export default {
  // 模块名称
  dhVideo: {}
}
